import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import { useLenis } from '@/lib/useLenis';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { Marquee } from '@/components/Marquee';
import { VideoShowcase } from '@/components/VideoShowcase';
import { WhatWeDo } from '@/components/WhatWeDo';
import { QualityTiers } from '@/components/QualityTiers';
import { OrderForm } from '@/components/OrderForm';
import { InternationalOrders } from '@/components/InternationalOrders';
import { ExportCTA } from '@/components/ExportCTA';
import { NewTireLoads } from '@/components/NewTireLoads';
import { Services } from '@/components/Services';
import { Testimonials } from '@/components/Testimonials';
import { Contact } from '@/components/Contact';
import { Footer } from '@/components/Footer';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { ClientProtectedRoute } from '@/components/ClientProtectedRoute';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import SignAgreement from '@/pages/SignAgreement';
import ClientLogin from '@/pages/ClientLogin';
import ClientDashboard from '@/pages/ClientDashboard';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import FAQPage from '@/pages/FAQPage';
import BlogIndexPage from '@/pages/BlogIndexPage';
import BlogPostPage from '@/pages/BlogPostPage';
import TestimonialsPage from '@/pages/TestimonialsPage';
import ServicesPage from '@/pages/ServicesPage';
import InternationalShippingPage from '@/pages/InternationalShippingPage';
import QualityGradesPage from '@/pages/QualityGradesPage';
import ExportDestinationPage from '@/pages/ExportDestinationPage';
import ExportHubPage from '@/pages/ExportHubPage';
import QuoteWizard from '@/pages/QuoteWizard';
import QuoteView from '@/pages/QuoteView';
import InvoiceView from '@/pages/InvoiceView';
import AdminQuotes from '@/pages/AdminQuotes';
import { ChatWidget } from '@/components/ChatWidget';

const Home = () => {
  useLenis();

  return (
    <div className="bg-brand-bg text-brand-text font-body min-h-screen">
      <Navbar />
      <Hero />
      <Marquee />
      <VideoShowcase />
      <WhatWeDo />
      <QualityTiers />
      <OrderForm />
      <InternationalOrders />
      <ExportCTA />
      <NewTireLoads />
      <Services />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/login" element={<ClientLogin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/blog" element={<BlogIndexPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/testimonials" element={<TestimonialsPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/international-shipping" element={<InternationalShippingPage />} />
      <Route path="/quality-grades" element={<QualityGradesPage />} />
      <Route path="/export" element={<ExportHubPage />} />
      <Route path="/export/:slug" element={<ExportDestinationPage />} />
      <Route path="/sign/:token" element={<SignAgreement />} />
      <Route path="/request-quote" element={<QuoteWizard />} />
      <Route path="/quote/:quoteNumber" element={<QuoteView />} />
      <Route path="/invoice/:invoiceNumber" element={<InvoiceView />} />
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/quotes"
        element={
          <ProtectedRoute>
            <AdminQuotes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <ClientProtectedRoute>
            <ClientDashboard />
          </ClientProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
        <ChatWidget />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
